import type { User } from '../../../modules/auth/core/_models'

/**
 * The one-time profile step (QA fix plan §4.1). A student whose profile is not
 * complete (infoCompleted from /auth/me; the server sets it on its own when the
 * data already exists) is sent to the profile form, and the portal's menu is
 * locked until they save it. Shared by StudentInfoGate (PrivateRoutes), the
 * portal shell and the form.
 */

export const PROFILE_PATH = '/student/dashboard/student-info'
export const HOME_PATH = '/student/dashboard'
export const PROFILE_LOCK_MESSAGE = 'Complete your profile first'

const STUDENT_ROLES = ['STUDENT', 'B2C_STUDENT', 'ROLE_STUDENT', 'ROLE_B2C_STUDENT']

/** True while a student still owes the profile step. Staff and super-admins never do. */
export function profileIncomplete(user: User | undefined | null): boolean {
  if (!user || user.superAdmin) return false
  const isStudent = (user.roles || []).some((r) => STUDENT_ROLES.includes(r))
  return isStudent && user.infoCompleted !== true
}

/** What the gate hands the form: the page the student asked for. */
export type ProfileGateState = { from?: string }

/**
 * Where the form goes after saving: the portal page the gate stopped the
 * student on, else the portal home. Never back to the form, never off the portal.
 */
export function pathAfterProfile(state: unknown): string {
  const from = (state as ProfileGateState | null)?.from
  if (typeof from !== 'string' || !from.startsWith('/student/')) return HOME_PATH
  if (from === PROFILE_PATH || from.startsWith(`${PROFILE_PATH}?`)) return HOME_PATH
  return from
}
